<template>
	<div>
		<div class="font-weight-bold">An {{ applicantName }} eine Zusage senden</div>
		<FormGroup class="mt-2">
			<RadioGroup
				v-model="collaboration"
				:options="collaborationOptions"
				stacked
			/>
		</FormGroup>
		<Interest
			v-if="collaborationInterest"
			:applicant-name="applicantName"
			:company-name="companyName"
			:text="message.collaborationTexts.interest"
			class="mt-3"
		/>
		<AgreementBasic
			v-if="collaborationAgreementBasic"
			:applicant-name="applicantName"
			:company-name="companyName"
			:text="message.collaborationTexts.agreementBasic"
			class="mt-3"
		/>
		<Promise
			v-if="collaborationPromise"
			:applicant-name="applicantName"
			:company-name="companyName"
			:text="message.collaborationTexts.promise"
			class="mt-3"
		/>
		<AgreementFull
			v-if="collaborationAgreementFull"
			:applicant-name="applicantName"
			:company-name="companyName"
			:text="message.collaborationTexts.agreementFull"
			class="mt-3"
		/>
		<div class="mt-3 text-right">
			<Button
				text="Senden / Bestätigen"
				icon="checkmark"
				:disabled="!dataValid || sendingRequest"
				:loading="sendingRequest"
				@click="submit"
			/>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group"
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import RadioGroup from "@/vue/common/form/RadioGroup";
import Interest from "./customer-interested/Interest"
import * as Collaboration from "@/helper/communication/conversation/Collaboration"
import Reply, {ACTION_COLLABORATION} from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import AgreementBasic from "@/vue/communication/conversation/customer-interested/AgreementBasic";
import AgreementFull from "@/vue/communication/conversation/customer-interested/AgreementFull";
import Promise from "@/vue/communication/conversation/customer-interested/Promise";
import {APPLICANT_INTERESTED_IN_COLLABORATION} from "@/helper/communication/conversation/Status";

export default {

	components: {
		AgreementBasic,
		AgreementFull,
		Promise,
		RadioGroup,
		FormGroup,
		Button,
		Interest,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			collaboration: undefined,
			sendingRequest: false,
		};
	},

	computed: {
		isApplicantInterest ()
		{
			return this.message.conversationStatus.id === APPLICANT_INTERESTED_IN_COLLABORATION;
		},
		applicantName ()
		{
			return this.message.disclosedData.name;
		},
		companyName ()
		{
			return this.message.customer.companyName;
		},
		collaborationInterest ()
		{
			return this.collaboration === Collaboration.INTEREST;
		},
		collaborationAgreementBasic ()
		{
			return this.collaboration === Collaboration.AGREEMENT_BASIC;
		},
		collaborationPromise ()
		{
			return this.collaboration === Collaboration.PROMISE;
		},
		collaborationAgreementFull ()
		{
			return this.collaboration === Collaboration.AGREEMENT_FULL;
		},
		collaborationOptions ()
		{
			let options = [];

			if (!this.isApplicantInterest)
			{
				options.push({
					value: Collaboration.INTEREST,
					text: 'Interesse an einer Zusammenarbeit mitteilen'
				});
			}

			options = _.concat(options, [
				{
					value: Collaboration.AGREEMENT_BASIC,
					text: 'Grundsätzliche Einigung beiderseits ist bereits erfolgt'
				},
				{
					value: Collaboration.PROMISE,
					text: 'Zusage jetzt senden'
				},
				{
					value: Collaboration.AGREEMENT_FULL,
					text: 'Vollständige Einigung beiderseits ist mittlerweile erfolgt'
				},
			]);

			return options;
		},
		collaborationValid ()
		{
			return isDefined(this.collaboration);
		},
		dataValid ()
		{
			return this.collaborationValid;
		}
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(ACTION_COLLABORATION)
					.setCollaboration(this.collaboration)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>